import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

import e from 'express';
import { EmployeesService } from '../../../../services/employees';



@Component({
  selector: 'app-allemployees',
  templateUrl: './allemployees.component.html',
  styleUrl: './allemployees.component.scss'
})
export class AllemployeesComponent {


  totalItems = 0;
  openEmployeeActionsId: string | number | null = null;
  employeeActionsMenuPosition = {
    top: '0px',
    left: '0px'
  };

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ["name", 'job_title', 'salary', 'address', 'national_id',
    'phone',
    'delete']

  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];

  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;

  city_id?: number;
  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  cartItems: any[] = [];
  cartItemCount: number = 0;
  allData: any[] = [];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _employessService: EmployeesService,

    private deviceService: DeviceDetectorService,
    private _userService: UserService,

    private excelExportService: ExcelExportService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();


    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
      
          this.getAllEmployees(1);
        
   
      },
      error: (error) => console.error(error),
    });
  }



  deleteitem(id: string) {
    this.closeEmployeeActions();
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._employessService.deleteEmployee(id).subscribe({
          next: (res) => {
            this.contentReady = false;
            this.getAllEmployees(1);
          },
          error: (err) => console.log(err),
        });
      }
    });

  }
  getAllEmployees(page: any) {
    this.contentReady = true;
    this.searched = false;
    this._employessService.getAllEmployees(page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.totalItems = data['total'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;

        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  showEmployee(itemobj: any) {
    this.closeEmployeeActions();
    this.router.navigate(['/employee'], { queryParams: itemobj });
  }


  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
  
      this.getAllEmployees(newPage);
 
  }
  edit(itemobj: any) {
    this.closeEmployeeActions();
    this.router.navigate(['/addemployee'], { queryParams: itemobj });
  }

  toggleEmployeeActions(event: MouseEvent, employeeId: string | number) {
    event.stopPropagation();
    if (this.openEmployeeActionsId === employeeId) {
      this.closeEmployeeActions();
      return;
    }

    const button = event.currentTarget as HTMLElement;
    const rect = button.getBoundingClientRect();
    const menuWidth = 180;
    const viewportPadding = 8;
    const left = Math.min(
      Math.max(rect.left, viewportPadding),
      window.innerWidth - menuWidth - viewportPadding
    );

    this.employeeActionsMenuPosition = {
      top: `${rect.bottom + 6}px`,
      left: `${left}px`
    };
    this.openEmployeeActionsId = employeeId;
  }

  closeEmployeeActions() {
    this.openEmployeeActionsId = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.closeEmployeeActions();
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  onViewportChange() {
    this.closeEmployeeActions();
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }


}
